<template>
  <div
      class="subheader py-2 py-lg-12 subheader-transparent"
      v-bind:class="subheaderClasses"
      id="kt_subheader"
  >

    <div
        class="align-items-center justify-content-between flex-wrap flex-sm-nowrap"
        v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >


      <div class="d-flex align-items-center flex-wrap mr-2">
        <!--begin::Heading-->
        <div class="d-flex flex-column">
          <!--begin::Title-->
          <h2 class="text-white font-weight-bold my-2 mr-5">
            {{ title }}
          </h2>
          <ul class="d-flex align-items-center font-weight-bold my-2">
            <router-link :to="'/'" class="opacity-75 hover-opacity-100">
              <i class="flaticon2-shelter text-white icon-1x"></i>
            </router-link>

            <template v-for="(breadcrumb, i) in breadcrumbs">
              <span
                  class="label label-dot label-sm bg-white opacity-75 mx-3"
                  :key="i"
              ></span>
              <router-link
                  :key="`${i}-${breadcrumb.id}`"
                  v-if="breadcrumb.route"
                  :to="breadcrumb.route"
                  class="text-white text-hover-white opacity-75 hover-opacity-100"
              >
                {{ breadcrumb.title }}
              </router-link>
              <span
                  class="text-white text-hover-white opacity-75 hover-opacity-100"
                  :key="`${i}-${breadcrumb.id}`"
                  v-if="!breadcrumb.route"
              >
                {{ breadcrumb.title }}
              </span>
            </template>
          </ul>
        </div>
<!--        <div class="mr-5"></div>-->
        <h1 class="text-center ml-10 offcanvas-mobile" id="bishin" style="color: white"></h1>

        <div class="w-75 text-center d-flex flex-column">



          <!--          <vue-typed-js class="mr-4"   :strings="text" >-->
          <!--            <h1 class="typing text-center " style="color: white"></h1>-->
          <!--          </vue-typed-js>-->
        </div>


      </div>
      <div class="mx-auto col-md-8">


        <!--begin::alert for complete profile-->
        <!--        <b-container>-->
        <!--          <b-alert show variant="warning" class="text-center text-dark complete-profile" v-if="this.getUserStatus() !== $STATUS.DONE ">-->
        <!--            لطفا پروفایل خود را تکمیل کنید !<br> برای تکمیل پروفایل می توانید <router-link to="/profile/my-profile"><b class="text-danger">اینجا</b></router-link> را کلیک کنید.-->
        <!--          </b-alert>-->
        <!--        </b-container>-->
        <!--end::alert for complete profile-->
      </div>
    </div>
  </div>
</template>

<style lang="css">
.complete-profile {
  background-color: #e50a96;
  border: 1px solid #f00c77;
}
</style>

<script>
import {mapGetters} from "vuex";

export default {
  name: "KTSubheader",

  props: {
    breadcrumbs: Array,
    title: String,
    flowTitles: Array
  },
  data() {
    return {
      loading: false,
      data: {},
      text: ['شسنمبسشمنبدشسمنزدشسمنزشسنمبدشسب', 'نمسایمنسشیاشسمزدشمسنزدمشنسزدمشنساز'],
      item: null,
    }
  },
  mounted() {
    this.loading = true


  },
  created() {
    this.fillTexts()

  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    textMain() {
      return this.layoutConfig("mainText")
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    }
  },
  watch:{
    flowTitles(){
      console.log("adfasdfasdf");
      this.fillTexts();
    }
  },
  methods:{
    fillTexts(){
      if (this.flowTitles && this.flowTitles.length){
        window.fillSubheaderText(this.flowTitles);
      }
    }
  }
};


</script>

